
// Define all available pages in the system with consistent IDs
export const ALL_PAGES = [
  { id: 'dashboard', name: 'Dashboard', path: '/' },
  { id: 'chippie-ai', name: 'Chippie AI', path: '/chippie-ai' },
  { id: 'my-approvals', name: 'My Approvals', path: '/my-approvals' },
  { id: 'knowledge-base', name: 'Knowledge Base', path: '/knowledge-base' },
  { id: 'farms', name: 'Farms', path: '/farms' },
  { id: 'harvests', name: 'Harvests', path: '/harvests' },
  { id: 'procurement', name: 'Procurement', path: '/procurement' },
  { id: 'suppliers', name: 'Suppliers', path: '/suppliers' },
  { id: 'agents', name: 'Agents', path: '/agents' },
  { id: 'coordinators', name: 'Coordination', path: '/coordinators' },
  { id: 'finance', name: 'Finance', path: '/finance' },
  { id: 'quality', name: 'Quality', path: '/quality' },
  { id: 'warehouse', name: 'Warehouse', path: '/warehouse' },
  { id: 'inventory', name: 'Inventory', path: '/inventory' },
  { id: 'reports', name: 'Reports', path: '/reports' },
  { id: 'users', name: 'User Management', path: '/users' },
  { id: 'settings', name: 'Settings', path: '/settings' },
  { id: 'price-benchmarking-data-entry', name: 'Data Entry', path: '/price-benchmarking/data-entry' },
  { id: 'price-forecast', name: 'Price Forecast', path: '/price-forecast' },
];

// Default access configuration - updated to include all roles and pages
export const DEFAULT_ACCESS_CONFIG: Record<string, string[]> = {
  admin: ALL_PAGES.map(page => page.id), // Admins have access to everything
  finance: ['dashboard', 'chippie-ai', 'procurement', 'suppliers', 'agents', 'finance', 'my-approvals'],
  warehouse: ['dashboard', 'chippie-ai', 'procurement', 'warehouse', 'inventory'],
  seller: ['dashboard', 'chippie-ai', 'procurement', 'suppliers', 'agents', 'price-benchmarking', 'price-forecast'],
  benchmark_manager: ['dashboard', 'chippie-ai', 'price-benchmarking', 'price-benchmarking-data-entry', 'price-forecast'],
  benchmark: ['dashboard', 'chippie-ai', 'price-benchmarking-data-entry'],
  coordinator: ['dashboard', 'chippie-ai', 'coordinators', 'farms', 'harvests'],
  quality: ['dashboard', 'chippie-ai', 'quality', 'inventory', 'reports'],
};

export const ROLES = ['admin', 'finance', 'warehouse', 'seller', 'benchmark_manager', 'benchmark', 'coordinator', 'quality'] as const;

export const STORAGE_KEY = 'roleAccessConfig';
